import { FaGlobe } from "react-icons/fa";
import { Link, NavLink } from "react-router-dom";

export default function Sidebar() {

    const list = [
        { link: "/Dashboard", name: "📊 Dashboard" },
        { link: "/Location", name: "📍 Locations" },
        { link: "/Translator", name: "🌐 Translator" },
        { link: "/Nearme", name: "🔍 Near Me" },
        { link: "/Foodapps", name: "🍔 Food Apps" },
        { link: "/Currency", name: "💱 Currency" },
        { link: "/Emergency", name: "⚠️ Emergency" },
        { link: "/Settings", name: "⚙️ Settings" },
    ]
    return (
        <div className="col-2 d-none d-md-block backgroundd text-white min-vh-100 p-0 position-fixed">
            <div className="d-flex align-items-center justify-content-center">
                <span className="card colorrr text-light p-1">
                    <FaGlobe size={20} />
                </span>
                <h4 className="p-3 mt-2"> TravelToolkit</h4>
            </div>
            <ul className="nav nav-pills flex-column px-1 mt-2 align-items-start w-100">
                {list.map((row, index) => (
                    <li className="nav-item  w-100" key={index}>
                        <NavLink
                            to={row.link} end
                            className={({ isActive }) => `nav-link text-light w-100 text-start ${isActive ? "active" : ""
                                }`}>
                            <button className="btn w-100 p-2 text-light">{row.name}</button>
                        </NavLink>
                    </li>
                ))}
            </ul>
        </div>
    );
}